import Spinner from 'components/Spinner';
import Card from 'components/Card';
import CardContent from 'components/CardContent';
import Note from 'components/Note';
import NoteForm from 'components/NoteForm';
import ImageView from 'components/ImageView';
import MediaView from 'components/MediaView';
import {separateMediaFiles} from 'helpers/media';

import CustomerDetails from './components/CustomerDetails';
import Header from './components/Header';
import Prescriptions from './components/Prescriptions';
import PreferenceTime from './components/PreferenceTime';
import useRequestDetails from './useRequestDetails';
import useUpdateDeliveryAddress from './useUpdateDeliveryAddress';

import styles from './RequestDetails.module.scss';
import useSendCustomerNotification from 'hooks/useSendCustomerNotification';
import {Fragment, Key, useCallback, useEffect, useMemo, useState} from 'react';
import toast from 'react-hot-toast';
import Modal from 'components/Modal';
import Typography from 'components/Typography';
import {get} from 'lodash';
import Button from 'components/Button';
import FormGroup from 'components/FormGroup';
import {Controller, useForm} from 'react-hook-form';
import {
  GooglePlaceAutoComplete,
  TypeGooglePlaceDetail,
} from 'components/GooglePlaceAutoComplete';
import TextField from 'components/TextField';
import useUserForm from 'pages/UserForm/useUserForm';
import {createAddress, Customer, DataTableSchemaItem} from 'types';
import MapPreview from 'components/MapPreview';
import useAuth from 'hooks/useAuth';
import {Link, useHistory} from 'react-router-dom';
import Select from 'components/Select';
import MessageModal from './components/MessageModal';
import DataTable from 'components/DataTable';
import CheckIcon from 'pages/Requests/CheckIcon';
import classNames from 'classnames';
import {formatPrice} from 'utils/format-price';
import ManualChargeModal from './components/ManualChargeModal';
import {
  TIMELINE_SORT_OPTIONS,
  TIMELINE_SORT_OPTIONS_LABELS,
} from 'constants/select-options';
import CreatePurchaseOrderModal from 'components/CreatePurchaseOrderModal';
import FeatureGuard from 'components/FeatureGuard';
import useCompanyConfig from 'hooks/useCompanyConfig';
import OrganizerBySequence from 'components/OrganizerBySequence';
import {getFullName} from 'helpers/user';
// import {useShopifyDetails} from './useShopifyDetails';

type FormData = createAddress;

const isVendor = (customer: Customer) => {
  return customer?.client_role === 'vendors';
};
function RequestDetails() {
  const {
    data,
    landlord,
    onChangeScriptStatus,
    onSubmitNote,
    chargeCard,
    onChangePreference,
    refetch,
    showMessageModal,
    setShowMessageModal,
    message,
    setMessage,
    sendChannels,
    setSendChannels,
    selectedTemplate,
    setSelectedTemplate,
    sendMessage,
    messageTemplates,
    orderItems,
    copayItems,
    setCopayItems,
    allSelected,
    setAllSelected,
    chargeManually,
    timelineSort,
    setTimelineSort,
    notes,
    form,
    selectedSplitItems,
    setSelectedSplitItems,
    isSplitting,
    splitOrderItems,
    isPropertyManager,
    manualChargeType,
    setManualChargeType,
    labels,
  } = useRequestDetails();

  // const {shopifyProducts, isShopifyProductsLoading} = useShopifyDetails(
  //   data?.external_order_id
  // );

  const {currentUser} = useAuth();
  const {push} = useHistory();

  const {addressIsUpdating, updateDeliveryAddress} = useUpdateDeliveryAddress();
  const {sendNotification} = useSendCustomerNotification();
  const [showAddressListModal, setShowAddressListModal] = useState(false);
  const [showNewAddressModal, setShowNewAddressModal] = useState(false);
  const [selectCardModal, setSelectCardModal] = useState(false);
  const [accessCardModal, setAccessCardModal] = useState(false);
  const [showChargeModal, setShowChargeModal] = useState(false);
  const [showCreatePurchaseOrderModal, setShowCreatePurchaseOrderModal] =
    useState(false);
  const [showImages, setShowImages] = useState(false);
  const [showMedia, setShowMedia] = useState(false);
  const [deliveryAddressId, setDeliveryAddressId] = useState(
    data?.delivery_address?.id
  );
  const [cardId, setCardIs] = useState('');
  const [isCharging, setIsCharging] = useState(false);
  const {control, setValue, handleSubmit, reset} = useForm<FormData>();
  const {createNewAddress, cards} = useUserForm(data?.customer.id);
  const {isPickupDropoff, layoutConfig} = useCompanyConfig();
  const [location, setLocation] = useState({
    latitude: 40.7596958,
    longitude: -73.9650045,
  });
  useEffect(() => {
    if (cards.length > 0) {
      const card = cards.find((item) => item.is_primary);
      setCardIs(card ? card.custom_uuid : cards[0].custom_uuid);
    }
  }, [cards]);

  const ORDER_ITEMS_SCHEMA: DataTableSchemaItem[] = useMemo(() => {
    if (manualChargeType === 'payable') {
      return [
        {
          dataKey: 'checkbox',
          header:
            copayItems.length > 0 ? (
              <div
                onClick={(val) => {
                  val.stopPropagation();
                }}
                className={styles.selectAll}
              >
                <div
                  onClick={(val) => {
                    setAllSelected(false);
                    setCopayItems([]);
                  }}
                  className={styles.selectAllIcon}
                >
                  <CheckIcon emptySelect={false} allSelected={allSelected} />
                </div>
                <Select
                  components={{
                    Input: () => null,
                    ValueContainer: () => null,
                  }}
                  styles={{
                    control: (base) => ({
                      ...base,
                      border: 'none',
                      backgroundColor: 'transparent',
                    }),
                    container: (base) => ({
                      ...base,
                      width: 70,
                    }),
                    option: (base) => ({
                      ...base,
                      paddingTop: 3,
                      paddingBottom: 3,
                      minHeight: 'auto !important',
                    }),
                    menuList: (base) => ({
                      ...base,
                      gap: 0,
                      padding: 0,
                    }),
                  }}
                  options={[
                    {label: 'All', value: 'all'},
                    {label: 'None', value: 'none'},
                  ]}
                  onChange={(val) => {
                    if (val?.value === 'all') {
                      setCopayItems(
                        data?.prescriptions?.map((item) => ({
                          id: item.id,
                          amount_due: item.payable_amount_due,
                        })) || []
                      );
                      setAllSelected(true);
                    } else if (val?.value === 'none') {
                      setCopayItems([]);
                      setAllSelected(false);
                    }
                  }}
                />
              </div>
            ) : (
              <div style={{height: 40}}></div>
            ),
          sortable: false,
          colWidth: '60px',
        },
        {
          dataKey: 'name',
          header: 'Item Name',
          sortable: false,
          colWidth: '150px',
        },
        {
          dataKey: 'type',
          header: 'Offering',
          colWidth: '100px',
        },
        {
          dataKey: 'quantity',
          header: 'Quantity',
          colWidth: '80px',
        },

        {
          dataKey: 'payable_total_amount',
          header: 'Total',
          colWidth: '60px',
        },
        {
          dataKey: 'payable_amount_due',
          header: 'Cost',
          colWidth: '100px',
        },
        {
          dataKey: 'profit',
          header: 'Profit',
          colWidth: '60px',
        },
      ] as DataTableSchemaItem[];
    } else if (manualChargeType === 'receivable') {
      return [
        {
          dataKey: 'checkbox',
          header:
            copayItems.length > 0 ? (
              <div
                onClick={(val) => {
                  val.stopPropagation();
                }}
                className={styles.selectAll}
              >
                <div
                  onClick={(val) => {
                    setAllSelected(false);
                    setCopayItems([]);
                  }}
                  className={styles.selectAllIcon}
                >
                  <CheckIcon emptySelect={false} allSelected={allSelected} />
                </div>
                <Select
                  components={{
                    Input: () => null,
                    ValueContainer: () => null,
                  }}
                  styles={{
                    control: (base) => ({
                      ...base,
                      border: 'none',
                      backgroundColor: 'transparent',
                    }),
                    container: (base) => ({
                      ...base,
                      width: 70,
                    }),
                    option: (base) => ({
                      ...base,
                      paddingTop: 3,
                      paddingBottom: 3,
                      minHeight: 'auto !important',
                    }),
                    menuList: (base) => ({
                      ...base,
                      gap: 0,
                      padding: 0,
                    }),
                  }}
                  options={[
                    {label: 'All', value: 'all'},
                    {label: 'None', value: 'none'},
                  ]}
                  onChange={(val) => {
                    if (val?.value === 'all') {
                      setCopayItems(
                        data?.prescriptions?.map((item) => ({
                          id: item.id,
                          amount_due: item.amount_due || 0,
                        })) || []
                      );
                      setAllSelected(true);
                    } else if (val?.value === 'none') {
                      setCopayItems([]);
                      setAllSelected(false);
                    }
                  }}
                />
              </div>
            ) : (
              <div style={{height: 40}}></div>
            ),
          sortable: false,
          colWidth: '60px',
        },
        {
          dataKey: 'name',
          header: 'Item Name',
          sortable: false,
          colWidth: '200px',
        },
        {
          dataKey: 'type',
          header: 'Offering',
          colWidth: '100px',
        },
        {
          dataKey: 'quantity',
          header: 'Quantity',
          colWidth: '50px',
        },

        {
          dataKey: 'amount_due',
          header: 'Amount Due',
          colWidth: '60px',
        },
      ] as DataTableSchemaItem[];
    }
    return [] as DataTableSchemaItem[];
  }, [
    manualChargeType,
    allSelected,
    copayItems.length,
    data?.prescriptions,
    setAllSelected,
    setCopayItems,
  ]);

  const handleCreation = async (datas: createAddress) => {
    const res = await createNewAddress({
      ...datas,
      customer_id: data?.customer.id,
    });

    if (get(res, 'status') === 200) {
      setShowNewAddressModal(false);
      setDeliveryAddressId(res.data.id);
      addressChangeHandler(res.data.id);
      reset();
      setLocation({
        latitude: 40.7596958,
        longitude: -73.9650045,
      });
    } else {
      toast.error('Something wrong with creation. Try again later !');
    }
  };

  const handleNotifyCustomer = useCallback(
    async (types: any, items: any[]) => {
      try {
        if (!get(currentUser, 'company.payment_integration')) {
          toast.error('Please, setup payment integration to notify customer');
          push('/settings/integrations', {
            show_modal: true,
          });
          return;
        }

        if (!data?.id) {
          return;
        }

        if (items.length > 0) {
          await sendNotification({
            requestId: data?.id,
            types: types,
            request_drugs: items,
          });
          refetch();
          toast.success('Notification sent successfully');
        }
      } catch (error) {
        const message = get(error, 'response.data.detail', 'Error try again');
        toast.error(message);
      }
    },
    [data?.id, currentUser, sendNotification, refetch, push]
  );

  const onCharge = async (id: number | undefined) => {
    if (cards.length < 1) {
      toast.error('Please add billing card to user first');
      sessionStorage.setItem('user_tab', 'cards');
      setTimeout(() => {
        push('/people/customers/' + data?.customer.id + '/edit');
      }, 1000);
      return;
    }
    setAccessCardModal(true);
  };

  const submitSelectedCard = async () => {
    if (!cardId) {
      return;
    }
    try {
      setIsCharging(true);
      await chargeCard({
        customer: data?.customer.id,
        payment_method_uuid: cardId,
        copay_items: copayItems,
      });
      setAccessCardModal(false);
      setSelectCardModal(false);
      toast.success('Successfully charged');
    } catch (error) {
      const message = get(error, 'response.data.detail', 'Error try again');
      toast.error(message);
    } finally {
      setIsCharging(false);
    }
  };

  const onChargeManually = async () => {
    try {
      if (!form.watch('payment_method')) {
        toast.error('Payment Type is required');
        return;
      }
      if (!form.watch('payer_type') && isPropertyManager) {
        toast.error('Payer Type is required');
        return;
      }
      setIsCharging(true);
      await chargeManually();
      setShowChargeModal(false);
      toast.success('Successfully charged');
    } catch (error) {
      const message = get(error, 'response.data.detail', 'Error try again');
      toast.error(message);
    } finally {
      setIsCharging(false);
      form.reset();
    }
  };

  const addressChangeHandler = async (id: number | string) => {
    updateDeliveryAddress({
      requestId: data?.id,
      addressId: id,
    })
      .then((res) => {
        onSubmitNote('', false);
        handleModalClose();
      })
      .catch((er) => {
        toast.error("You can't change address!");
        if (process.env.NODE_ENV === 'development') {
          console.error('Error on updating:', er);
        }
      });
  };

  function modalHandler() {
    setDeliveryAddressId(data?.delivery_address.id);
    setShowAddressListModal(true);
  }
  const handleModalClose = () => setShowAddressListModal(false);

  const onSelectPlace = (placeDetail: TypeGooglePlaceDetail) => {
    setValue('latitude', placeDetail.lat);
    setValue('longitude', placeDetail.lon);
    setTimeout(() => {
      setLocation({latitude: placeDetail.lat, longitude: placeDetail.lon});
    }, 300);
    setValue('zipcode', placeDetail.zipcode);
    setValue('address_line_1', placeDetail.addressLine1);
    setValue('city', placeDetail.city);
    setValue('state', placeDetail.state);
  };

  const selectedCard = cards.find((item) => item.custom_uuid === cardId);
  const hasPropertyDetails =
    !!get(data, 'company_property.name', null) || !!landlord;

  const lastNoteWithRouteId = data?.notes?.findLast((note) =>
    note.text.includes('Route ID')
  );
  if (
    !data
    // || isShopifyProductsLoading
  )
    return (
      <div className={styles.spinnerContainer}>
        <Spinner />
      </div>
    );

  return (
    <div>
      <Header
        order={data}
        onCreatePurchaseOrder={() => setShowCreatePurchaseOrderModal(true)}
        onClickNotify={() => setShowMessageModal(true)}
        refetchRequest={refetch}
        onSendToDispatch={onChangeScriptStatus}
      />

      <div className={styles.content}>
        <div className={classNames(styles.drugs)}>
          <div
            className={classNames(isPickupDropoff && styles.resellerContent, {
              [styles.pickup]: data?.order_type === 'pickup',
              [styles.dropoff]: data?.order_type === 'dropoff',
            })}
          >
            <CustomerDetails
              pharmacy={data.pharmacy}
              customer={data.customer}
              deliveryData={data?.delivery_address}
              modalHandler={modalHandler}
              orderType={data?.order_type}
            />
            <OrganizerBySequence sequences={layoutConfig.orderDetailsSequence}>
              <PreferenceTime
                key="1"
                status={data?.prescriptions[0]?.status}
                drugId={data?.prescriptions[0]?.id}
                onChangeStatus={(newVal: any, action: any) => {
                  onChangeScriptStatus(newVal, action, data?.id);
                }}
                details={data}
                onChangePreference={onChangePreference}
                googleDriveFiles={data?.google_drive_files || []}
              />
              <FeatureGuard key="2" feature="hasPropertyDetailsOnOrderDetails">
                {hasPropertyDetails && (
                  <Card>
                    <CardContent pt="md" className={styles.grid}>
                      <div className={styles.sectionHeader}>
                        <h2 className={styles.sectionTitle}>
                          {labels.property} Details
                        </h2>
                      </div>
                      <div style={{gridArea: 'left'}}>
                        {!!get(data, 'company_property.name', null) && (
                          <Fragment>
                            <Typography component="p" variant="label">
                              {labels.property}
                            </Typography>

                            <Typography
                              className={styles.text}
                              component="p"
                              variant="label"
                            >
                              {get(data, 'company_property.name', null)}
                            </Typography>
                          </Fragment>
                        )}
                        {!!landlord && (
                          <Fragment>
                            <Typography component="p" variant="label">
                              {labels.landlord}
                            </Typography>

                            <Typography
                              className={styles.text}
                              component="p"
                              variant="label"
                            >
                              {`${landlord?.first_name} ${landlord?.last_name}` ||
                                `No ${labels.landlord}`}
                            </Typography>
                          </Fragment>
                        )}
                        {!!get(data, 'description', null) && (
                          <Fragment>
                            <Typography component="p" variant="label">
                              Issue Description
                            </Typography>

                            <Typography
                              className={styles.text}
                              component="p"
                              variant="label"
                            >
                              {get(data, 'description', null)}
                            </Typography>
                          </Fragment>
                        )}
                      </div>
                      <div style={{gridArea: 'right'}}>
                        {!!get(data, 'images', null) &&
                          !!data?.images?.length && (
                            <Fragment>
                              {(() => {
                                const {images, videos} = separateMediaFiles(
                                  data?.images || []
                                );

                                return (
                                  <Fragment>
                                    <Typography component="p" variant="label">
                                      Attachments
                                    </Typography>
                                    {/* Images Section */}
                                    {images.length > 0 && (
                                      <Fragment>
                                        <ImageView
                                          show={showImages}
                                          onClose={() => setShowImages(false)}
                                          images={images.map(
                                            (image) => image?.large
                                          )}
                                        />
                                        {images.map((image) => (
                                          <img
                                            key={image.id}
                                            onClick={() => setShowImages(true)}
                                            src={image?.thumbnail}
                                            alt={image?.file}
                                            className={styles.attachedImage}
                                          />
                                        ))}
                                      </Fragment>
                                    )}

                                    {/* Videos Section */}
                                    {videos.length > 0 && (
                                      <Fragment>
                                        <MediaView
                                          show={showMedia}
                                          onClose={() => setShowMedia(false)}
                                          mediaItems={videos}
                                        />
                                        {videos.map((video) => (
                                          <div
                                            key={video.id}
                                            onClick={() => setShowMedia(true)}
                                            className={styles.attachedVideo}
                                          >
                                            <video
                                              src={video?.thumbnail}
                                              className={styles.videoThumbnail}
                                              muted
                                            />
                                            <div
                                              className={styles.videoOverlay}
                                            >
                                              <svg
                                                width="48"
                                                height="48"
                                                viewBox="0 0 24 24"
                                                fill="white"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <path d="M8 5v14l11-7z" />
                                              </svg>
                                            </div>
                                          </div>
                                        ))}
                                      </Fragment>
                                    )}
                                  </Fragment>
                                );
                              })()}
                            </Fragment>
                          )}
                      </div>
                    </CardContent>
                  </Card>
                )}
              </FeatureGuard>

              {data.prescriptions.length > 0 && (
                <Prescriptions
                  key="3"
                  data={data}
                  isSplitting={isSplitting}
                  refetch={refetch}
                  onCharge={onCharge}
                  onSendNotification={handleNotifyCustomer}
                  selectedSplitItems={selectedSplitItems}
                  setSelectedSplitItems={setSelectedSplitItems}
                  onSplit={splitOrderItems}
                  onChargeManually={(type) => {
                    setManualChargeType(type);
                    setShowChargeModal(true);
                  }}
                />
              )}
            </OrganizerBySequence>
          </div>
        </div>
        <div className={styles.main_content}>
          <FeatureGuard feature="hasLinkedOrderOnOrderDetails">
            {data?.pickup_dropoffs?.length > 0 && (
              <Card>
                <CardContent pt="sm">
                  <div className={styles.sectionHeader}>
                    <h2 className={styles.sectionTitle} style={{margin: 0}}>
                      Linked{' '}
                      {data?.order_type === 'dropoff'
                        ? 'Pickup Order'
                        : 'Dropoff Orders'}
                    </h2>
                  </div>
                  <div className={styles.linkedOrdersGrid}>
                    {data?.pickup_dropoffs?.map((order) => (
                      <Link
                        to={`/orders/${order.sequential_order_number}`}
                        key={order.id}
                        className={styles.linkedOrderItem}
                      >
                        <Typography
                          variant="strong"
                          className={styles.linkedOrderItemTitle}
                        >
                          #{order.sequential_order_number} -{' '}
                          {isVendor(order.customer)
                            ? order.customer.customer_company
                            : getFullName(order.customer.user)}
                        </Typography>
                      </Link>
                    ))}
                  </div>
                </CardContent>
              </Card>
            )}
          </FeatureGuard>
          {data?.tracking_id && (
            <Card>
              <CardContent pt="sm" pb="none">
                <div className={styles.sectionHeader}>
                  <h2 className={styles.sectionTitle} style={{margin: 0}}>
                    Tracking ID:
                  </h2>
                  <a
                    href={`/track?id=${data.tracking_id}`}
                    target="_blank"
                    rel="noreferrer"
                    className={styles.trackingLink}
                  >
                    #{data?.sequential_order_number}
                  </a>
                </div>
              </CardContent>
            </Card>
          )}
          <Card>
            <CardContent>
              <NoteForm
                onSubmit={onSubmitNote}
                isCompleted={
                  get(data, 'status', '') === 'completed' &&
                  !!get(data, 'route_id', null)
                }
              />
              <div className={styles.sortContainer}>
                <Select
                  placeholder="Sort by"
                  options={TIMELINE_SORT_OPTIONS}
                  styles={{
                    control: (base) => ({
                      ...base,
                      marginTop: 10,
                      width: '200px',
                    }),
                  }}
                  value={{
                    label: TIMELINE_SORT_OPTIONS_LABELS[timelineSort],
                    value: timelineSort,
                  }}
                  onChange={(value) => setTimelineSort(value?.value as any)}
                />
              </div>
              {notes?.map((note, index) => (
                <Note
                  key={note.id}
                  note={note}
                  isCompleted={
                    get(data, 'status', '') === 'completed' &&
                    index === 0 &&
                    !!get(data, 'route_id', null)
                  }
                  transactions={data?.transactions || []}
                  isRouteClickable={
                    !!lastNoteWithRouteId && note.id === lastNoteWithRouteId.id
                  }
                  route_id={Number(get(data, 'route_id', null))}
                />
              ))}
            </CardContent>
          </Card>
        </div>
      </div>
      <Modal
        isOpen={showAddressListModal}
        onClose={handleModalClose}
        className={styles.list_wrapper}
      >
        <Typography component="p" className={styles.modalDesc} variant="h2">
          Select Delivery Address:
        </Typography>
        <div className={styles.optionWrapper}>
          {get(data.customer, 'delivery_addresses', []).map(
            (item: any, index: Key | null | undefined) => {
              return (
                <label key={index} className={styles.container}>
                  <input
                    type="radio"
                    name="radio"
                    defaultChecked={deliveryAddressId === item.id}
                    onClick={() => setDeliveryAddressId(item.id)}
                  />
                  <span className={styles.radioButtonText}>
                    {get(item, 'address_line_1', '')}, {get(item, 'city', '')},{' '}
                    {get(item, 'state', '')}, {get(item, 'zipcode', '')}
                    {get(item, 'unit_address', '')
                      ? `, ${get(item, 'unit_address', '')}`
                      : ''}
                  </span>
                  {!get(item, 'is_valid', true) && (
                    <span className={styles.wrongAddress}>issue</span>
                  )}
                </label>
              );
            }
          )}
          <div
            onClick={() => setShowNewAddressModal(true)}
            className={styles.addAddress}
          >
            + Add address
          </div>
        </div>
        <div className={styles.actions}>
          <Button
            type="submit"
            onClick={() => addressChangeHandler(deliveryAddressId || 0)}
            size="md"
            loading={addressIsUpdating}
          >
            Submit
          </Button>
        </div>
      </Modal>

      <Modal
        isOpen={showNewAddressModal}
        onClose={() => setShowNewAddressModal(false)}
        className={styles.list_wrapper}
      >
        <div className={styles.modalWrapper}>
          <FormGroup>
            <Controller
              name="city"
              control={control}
              rules={{required: 'Please, Select the address'}}
              render={({field, fieldState}) => (
                <GooglePlaceAutoComplete
                  label="Your address"
                  placeholder="Address"
                  onPlaceSelected={onSelectPlace}
                  error={fieldState.error?.message}
                  options={{
                    types: ['address'],
                  }}
                />
              )}
            />
            <Controller
              name="unit_address"
              control={control}
              render={({field, fieldState}) => (
                <TextField
                  label="Unit number"
                  wrapperClass={styles.googleInput}
                  placeholder="Enter unit number"
                  hasError={false}
                  onChange={field.onChange}
                  error={fieldState.error?.message}
                />
              )}
            />
          </FormGroup>

          <div
            style={{
              alignItems: 'center',
              display: 'flex',
              flexDirection: 'column',
              paddingTop: 20,
            }}
          >
            {!!location.latitude && (
              <MapPreview
                zoom={15}
                onDrag={(location) => {
                  setValue('latitude', location.lat);
                  setValue('longitude', location.lon);
                }}
                center={[location.latitude, location.longitude]}
              />
            )}
          </div>

          <div className={styles.actionWrapper}>
            <Button type="submit" onClick={handleSubmit(handleCreation)}>
              Add
            </Button>
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={selectCardModal}
        onClose={() => setSelectCardModal(false)}
        className={styles.list_wrapper}
      >
        <Typography component="p" className={styles.modalDesc} variant="h2">
          Select Card to Charge:
        </Typography>
        <div className={styles.optionWrapper}>
          {cards.map((item: any, index: Key | null | undefined) => {
            return (
              <label key={index} className={styles.radioOption}>
                <input
                  type="radio"
                  name="radio"
                  defaultChecked={cardId === item.custom_uuid}
                  onClick={() => setCardIs(item.custom_uuid)}
                />
                <span className={styles.radioButtonText}>
                  {get(item, 'cardholder_name', '')}
                </span>
                <p
                  style={{marginLeft: 'auto'}}
                  className={styles.radioButtonText}
                >
                  **** **** **** {get(item, 'last4', '')}
                </p>
              </label>
            );
          })}
        </div>
        <div className={styles.actions}>
          <Button
            type="submit"
            onClick={() => setAccessCardModal(true)}
            size="md"
            loading={addressIsUpdating}
          >
            Submit
          </Button>
        </div>
      </Modal>
      <Modal
        isOpen={accessCardModal}
        onClose={() => setAccessCardModal(false)}
        className={styles.list_wrapper}
      >
        <Typography component="p" className={styles.modalDesc} variant="h2">
          Confirm Card for Charge
        </Typography>
        <Select
          styles={{
            control: (base) => ({
              ...base,
              marginTop: 20,
            }),
          }}
          placeholder="Select card"
          value={
            selectedCard && {
              label:
                (get(selectedCard, 'cardholder_name', '') ||
                  ' **** **** ****') +
                ' - ' +
                selectedCard?.last4 +
                (get(selectedCard, 'is_primary') ? ' / Primary' : ''),
              value: selectedCard?.custom_uuid,
            }
          }
          onChange={(value) => {
            if (value) setCardIs(value.value as string);
          }}
          options={cards.map((item) => ({
            label:
              (get(item, 'cardholder_name', '') || ' **** **** ****') +
              ' - ' +
              +get(item, 'last4', '') +
              ' ' +
              (get(item, 'is_primary') ? ' / Primary' : ''),
            value: item.custom_uuid,
          }))}
        />
        <div className={classNames(styles.row, styles.totalAmount)}>
          <Typography variant="h3">Order Items</Typography>
          <Typography variant="h3">
            Total:&nbsp;
            {formatPrice(
              copayItems.reduce(
                (pr: number, curr: any) => pr + Number(curr.amount_due),
                0
              )
            )}
          </Typography>
        </div>
        <DataTable schema={ORDER_ITEMS_SCHEMA} data={orderItems || []} />
        <div className={styles.actions}>
          <Button
            type="submit"
            onClick={submitSelectedCard}
            size="md"
            disabled={!selectedCard || copayItems.length === 0 || isCharging}
            loading={isCharging}
          >
            Charge
          </Button>
        </div>
      </Modal>

      <MessageModal
        selectedTemplate={selectedTemplate}
        messageTemplates={messageTemplates!}
        isOpen={showMessageModal}
        sendChannels={sendChannels}
        sendMessage={sendMessage}
        onSelect={(option) => {
          setSelectedTemplate(option!);
          setMessage(option?.value as string);
        }}
        username={`${get(data, 'customer.user.first_name', '')} ${get(
          data,
          'customer.user.last_name',
          ''
        )}`}
        onClose={() => {
          setShowMessageModal(false);
          setMessage('');
          setSelectedTemplate(undefined);
        }}
        handleChannelChange={(name: string, isChecked: boolean) =>
          setSendChannels((prev) => ({...prev, [name]: isChecked}))
        }
      >
        <textarea
          className={styles.messageTextarea}
          placeholder="Message"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
      </MessageModal>
      {showChargeModal && (
        <ManualChargeModal
          isOpen={showChargeModal}
          onClose={() => setShowChargeModal(false)}
          schema={ORDER_ITEMS_SCHEMA}
          data={orderItems || []}
          copayItems={copayItems || []}
          onChargeManually={onChargeManually}
          isCharging={isCharging}
          disabled={copayItems.length === 0 || isCharging}
          form={form}
          manualChargeType={manualChargeType}
        />
      )}

      {showCreatePurchaseOrderModal && (
        <CreatePurchaseOrderModal
          dropoff_ids={[data?.id]}
          orderItems={data?.prescriptions?.map((item) => item.drug) || []}
          isOpen={showCreatePurchaseOrderModal}
          onClose={() => setShowCreatePurchaseOrderModal(false)}
          onSuccess={refetch}
        />
      )}
    </div>
  );
}

export default RequestDetails;
